import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./other_files/reportWebVitals";
import { notifInitialization, ggTemplateInit } from "./services/defined.action";

/** DECLARED GLOBAL VARIABLES */
window.globalData = {
  addNewLink: "",
  viewLink: "",
  editLink: "",
};
// $("body").toggleClass("mini-navbar");
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

//initialize notiflix popu
notifInitialization();
ggTemplateInit();
